import { formReducer, modelReducer } from 'react-redux-form'
import { combineReducers } from 'redux'

import * as actions from '../../actions/admin/adminUserActions'
import * as h2Api from '../../h2Api'

const initialFormState = {
  name: ''
}

export default combineReducers({
  state: (state = {}, action) => {
    if (action.type === actions.CONFIRM_REMOVE_USER) {
      return {
        user: action.user,
        scope: action.scope
      }
    }

    return state
  },
  deleteRequest: h2Api.restReducer(actions.DELETE_USER),
  removeFromManagementRequest: h2Api.restReducer(actions.REMOVE_USER_FROM_MANAGEMENT),
  removeFromSiteRequest: h2Api.restReducer(actions.REMOVE_USER_FROM_SITE),
  form: modelReducer('admin.users.remove.form', initialFormState),
  forms: formReducer('admin.users.remove', { form: initialFormState })
})
